export enum UserTypeEnum {
  Administrator = "Administrator",
  Operations = "Operations",
  Sistema = "Sistema",
  Consorcio_Administradora = "Consorcio_Administradora",
  Custody = "Custody",
  PAN_Operations = "PAN_Operations",
  Business_Partner = "Business_Partner",
  Business_Partner_Ops = "Business_Partner_Ops",
  Business_Partner_External = "Business_Partner_External",
  Integracoes = "Integracoes",
  Business_Partner_External_Cooperativa = "Business_Partner_External_Cooperativa",
  Business_Partner_External_Filiado = "Business_Partner_External_Filiado"
}

export const CognitoUserTypeMap = new Map<UserTypeEnum, string>([
  [UserTypeEnum.Administrator, "admin"],
  [UserTypeEnum.Operations, "admin"],
  [UserTypeEnum.Consorcio_Administradora, "admin"],
  [UserTypeEnum.Custody, "admin"],
  [UserTypeEnum.PAN_Operations, "admin"],
  [UserTypeEnum.Sistema, "system"],
  [UserTypeEnum.Business_Partner, "admin"],
  [UserTypeEnum.Business_Partner_Ops, "admin"],
  [UserTypeEnum.Business_Partner_External, "admin"],
  [UserTypeEnum.Integracoes, "admin"],
  [UserTypeEnum.Business_Partner_External_Cooperativa, "admin"],
  [UserTypeEnum.Business_Partner_External_Filiado, "admin"],
]);



// WEBPACK FOOTER //
// ./src/services/enum/UserTypeEnum.ts